import { isPlatformBrowser, NgIf } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { FuseLoadingService } from '@fuse/services/loading';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { CustomerService } from 'app/core/shared-services/customer.service';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { finalize } from 'rxjs';

@Component({
    selector     : 'auth-confirmation-required',
    templateUrl  : './confirmation-required.component.html',
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations,
    standalone   : true,
    imports      : [RouterLink, NgIf],
})
export class AuthConfirmationRequiredComponent
{
    public text: string;
    public success: boolean;
    public redirectURL: string;

    private referrer: string;

    /**
     * Constructor
     */
    constructor(
        private customerService: CustomerService,
        private activatedRouter: ActivatedRoute,
        private router: Router,
        private loadingSpinner: FuseSplashScreenService,
        private _gtmService: GtmService,

        @Inject(PLATFORM_ID) private platformId: any
    )
    {

    }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  async ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {

        if(localStorage.getItem('currentURL')) {
          if(localStorage.getItem('currentURL') == window.location.href) {
            //this.referrer = window.location.href
          } else {
            this.referrer = localStorage.getItem('currentURL')
            localStorage.setItem('currentURL', window.location.href);
            localStorage.setItem('previousURL', this.referrer);
          }
        } else {
          localStorage.setItem('currentURL', window.location.href);
        }
        
        const route = window.location.href;
        const path = this.router.url;
        this._gtmService.pushEvent({ 
          event: 'fibre_page' ,
          page_url: route,
          page_path: path,
          page_referrer: this.referrer ? this.referrer : route
        });
      }
      
    this.loadingSpinner.show();
    const token = this.activatedRouter.snapshot.queryParamMap.get('token');
    if (token) {
        this.customerService.verifyEmail(token)
            .subscribe({
                next: () => {
                    this.text = 'Your e-mail was successfully verified!';
                    this.success = true;
                    // this.redirectUrlCheck();
                    this.loadingSpinner.hide();

                },
                error: (err) => {
                    // this.text = err.error.Message;
                    this.success = false;
                    this.loadingSpinner.hide();
                },
                
            })
    }
  }


//   private redirectUrlCheck(): void {
//      
//     if(localStorage.getItem('redirectUrl')) {
//         this.redirectURL = localStorage.getItem('redirectUrl');
//         localStorage.removeItem('redirectUrl');
//     }
//     else {
//         this.redirectURL = '/sign-in';
//     }
//     // Navigate to the redirect url
//     this._router.navigateByUrl(this.redirectURL);

//   }
}